import React from "react";
import { useNavigate } from "react-router-dom";
import s from "~/components/common/Patient/Patient.module.scss";
import ROUTES from "~/utils/routes";
import { logEvent } from "~/utils/amplitude";

interface Props {}

const PatientControlPanel: React.FC<Props> = () => {
  const navigate = useNavigate();

  const changePatient = () => {
    logEvent("Д/ Нажал кнопку сменить пациента / Блок о пациенте");
    navigate(ROUTES.LOGIN.PATHNAME, { replace: true });
  };

  const redirectToJournal = () => {
    logEvent("Д/ Нажал кнопку журнал пациента / Блок о паициенте");
    navigate(ROUTES.JOURNAL.PATHNAME, { replace: true });
  };

  return (
    <div className={s.patientControls}>
      <button
        className={"button " + s.patientControlsChangeBtn}
        onClick={changePatient}
      >
        Сменить пациента
      </button>
      <button
        className={"button " + s.patientControlsJournalBtn}
        onClick={redirectToJournal}
      >
        Журнал посещений
      </button>
    </div>
  );
};

export default PatientControlPanel;
